import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/AsesmenAwalRanapMedis";
import { AsesmenAwalRanapMedisData } from "@/types/asesmen_awal_ranap_medis";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "asesmen-awal-ranap-medis"
})
class AsesmenAwalRanapMedisStore extends VuexModule {
  loading = false;
  asesmen: AsesmenAwalRanapMedisData = null;
  isAnyUnsavedChange = false;

  @Mutation
  SET_RECORD(val) {
    this.asesmen = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.asesmen = null;
    this.isAnyUnsavedChange = false;
    this.loading = false;
  }

  @Mutation
  SET_IS_ANY_UNSAVED_CHANGE(val) {
    this.isAnyUnsavedChange = val;
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_RECORD(response.data?.data);
  }

  @Action({ rawError: true })
  setRecord(val: AsesmenAwalRanapMedisData | null): void {
    this.SET_RECORD(val);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }

  @Action({ rawError: true })
  setIsAnyUnsavedChange(val): void {
    this.SET_IS_ANY_UNSAVED_CHANGE(val);
  }
}

export default getModule(AsesmenAwalRanapMedisStore);
